import { listAdapterRegistry } from "sulu-admin-bundle/containers";

import InlineTableAdapter from "./InlineTableAdapter";

const registerAdapters = () => {
    listAdapterRegistry.add("custom_table", InlineTableAdapter);
};

export default registerAdapters;
